module.exports = __webpack_public_path__ + "img/marquee-img.1192f747.webp";